module.exports = __webpack_public_path__ + "static/media/proakt-news-mobile.1148eb65.png";